import {Inject, LOCALE_ID, Pipe, PipeTransform} from '@angular/core';
import {formatDate} from '@angular/common';
import {DATE_FORMAT_SECONDS} from '../../consts/date-time-format-consts';
import {MX_TIMEZONE_TOKEN, MxTimezoneService} from '../services/mx-timezone.service';

@Pipe({
    name: 'zoneDate',
    standalone: false,
})
export class ZoneDatePipe implements PipeTransform {
    constructor(
        @Inject(LOCALE_ID) private locale: string,
        @Inject(MX_TIMEZONE_TOKEN) private timezoneService: MxTimezoneService) {
    }

    transform(value: number, format?: string): string {
        if (!format) {
           format = DATE_FORMAT_SECONDS;
        }
        if (value) {
            let timezone = this.timezoneService.getOffset();
            return formatDate(value, format, this.locale, timezone);
        }
        return null;
    }
}
